import React from 'react'
import {
  useHideModal,
  useIsShowModal,
  useSetActiveModal,
} from 'src/Modal/ModalStateContext'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import styled from 'styled-components/macro'
import { ModalForm, ModalFormId } from '../../..'
import { Spinner } from '../../../../../Throbber'
import { useFrameworkWizard } from '../../../../../context/FormContext'
import { SelectControlsModal } from './SelectControlsModal'

const StyledUl = styled.ul`
  margin-top: 1em;
`

const ControlsListContainer = ({
  controls,
}: {
  controls: Control[]
}): JSX.Element => {
  return (
    <StyledUl>
      {controls.map((control) => (
        <ControlListItem key={control.getId()} control={control} />
      ))}
    </StyledUl>
  )
}

const ControlListItem = ({ control }: { control: Control }): JSX.Element => {
  const controlId = control.getId()
  const controlName = IsGatekeeperEnabled(GatekeeperFlag.CONTROL_IDS)
    ? `${control.getModelId()} ${control.getName()}`
    : control.getName()

  return (
    <li key={controlId}>
      <span>{controlName}</span>
    </li>
  )
}

export const ReusableControlsModal = (): JSX.Element => {
  const {
    frameworkState: { framework },
    controlsState: { controlsInAccount },
    loadingState: { loading },
  } = useFrameworkWizard()
  const hide = useHideModal({ modalId: ModalFormId.REUSABLE_CONTROLS })
  const show = useIsShowModal(ModalFormId.REUSABLE_CONTROLS)
  const back = useSetActiveModal(ModalFormId.CHOOSE_COMPLIANCE_FRAMEWORK)

  return (
    <div>
      <SelectControlsModal />
      <ModalForm
        show={show}
        hide={hide}
        formId={ModalFormId.REUSABLE_CONTROLS}
        size="xl"
        title={`Linking Existing Controls to ${framework?.getName()}`}
        onBack={back}
        customSubmitButton={
          <StandardOpenModalButton modalId={ModalFormId.SELECT_CONTROLS} />
        }
      >
        {loading ? (
          <Spinner color={'primary'} size={'m'} />
        ) : (
          <form id={ModalFormId.REUSABLE_CONTROLS}>
            <p>{`Good news! ${
              controlsInAccount.length
            } of your controls can be used for ${framework?.getName()}`}</p>
            <ControlsListContainer controls={controlsInAccount} />
          </form>
        )}
      </ModalForm>
    </div>
  )
}
